import { SvgIcon, SvgIconProps } from '@mui/material';

export const TabBarOffersStarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M9.07495 16.25L12 14.475L14.925 16.25L14.15 12.925L16.75 10.675L13.325 10.4L12 7.24995L10.675 10.4L7.24995 10.675L9.84995 12.925L9.07495 16.25ZM12 23.3L8.64995 20H3.99995V15.35L0.699951 12L3.99995 8.64995V3.99995H8.64995L12 0.699951L15.35 3.99995H20V8.64995L23.3 12L20 15.35V20H15.35L12 23.3ZM12 20.5L14.5 18H18V14.5L20.5 12L18 9.49995V5.99995H14.5L12 3.49995L9.49995 5.99995H5.99995V9.49995L3.49995 12L5.99995 14.5V18H9.49995L12 20.5Z" />
    </SvgIcon>
  );
};
